import { useMemo } from 'react';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import Button, { ButtonProps } from 'src/components/design-system/Button';
import PopUp from 'src/components/design-system/PopUp';
import { IInvoiceListItem } from 'src/types/Invoice';

interface IActionButton {
  btn: {
    text: string;
    color: ButtonProps['color'];
    onClick: VoidFunction;
    disabled: boolean;
    permissions: string[];
    invalidIds: (string | undefined)[];
    type: 'PO' | 'Doc';
    isLoading: boolean;
  };
  selectedInvoices: IInvoiceListItem[];
}

const ActionButton: React.FC<IActionButton> = ({ btn, selectedInvoices }) => {
  const contents = useMemo(() => {
    if (!selectedInvoices.length) {
      return [`Please select one or more records to ${btn.text}`];
    }

    if (btn.invalidIds.length) {
      return btn.invalidIds.map((invalidId) => `# ${invalidId || ''}`);
    }

    return [];
  }, [btn.invalidIds, btn.text, selectedInvoices.length]);

  return (
    <PopUp
      show={btn?.disabled}
      content={
        <div className="max-h-[60vh] overflow-auto">
          <PopUpContentWrapper
            type={selectedInvoices.length ? 'Error' : 'Information'}
            contents={contents}
            prefix={selectedInvoices.length ? btn.text : undefined}
            title={
              selectedInvoices.length ? `Documents below are ineligible to ${btn.text}` : undefined
            }
          />
        </div>
      }
    >
      <Button
        disabled={btn?.disabled}
        loading={btn.isLoading}
        color={btn?.color}
        onClick={btn?.onClick}
      >
        {btn.text}
      </Button>
    </PopUp>
  );
};

export default ActionButton;
